import { useEffect, useState } from 'react';
import { CARDS_IN_ROW } from '../../../constants';
import { useChannelEntitiesQuery } from '../../../queries';

export const useFeaturedChannelEntities = ({
  allowUnfeatured,
  channelId,
}: {
  allowUnfeatured?: boolean;
  channelId: string;
}) => {
  const [isFeatured, setIsFeatured] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsFeatured(true);
  }, [channelId]);

  const query = useChannelEntitiesQuery({
    channelId,
    featured: isFeatured,
    pageSize: CARDS_IN_ROW,
  });

  useEffect(() => {
    if (isFeatured && allowUnfeatured && query.data?.pages[0]?.length === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsFeatured(false);
    }
  }, [allowUnfeatured, isFeatured, query.data?.pages]);

  return { isFeatured, query };
};
